export default "__VITE_ASSET__BlIiRff7__"